import { useEffect, useRef } from 'react';

// Keep the conversation and composer inside the visible area when the iOS keyboard opens.
export default function useConversationViewport() {
  const ref = useRef(null);
  useEffect(() => {
    const viewport = window.visualViewport;
    const update = () => {
      const height = viewport?.height || window.innerHeight;
      if (ref.current) ref.current.dataset.compactViewport = String(height < 400);
      ref.current?.style.setProperty('--conversation-height', `${height}px`);
      ref.current?.style.setProperty('--conversation-top', `${viewport?.offsetTop || 0}px`);
    };
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return ref;
}
